'use client';

import { styled } from '@mui/material/styles';
import ButtonBase from './buttonBase';

const ButtonOnDark = styled(ButtonBase)(({ theme, variant, disabled }) => ({
  color: theme.palette.colorTheme.contentPrimaryOnLight,
  backgroundColor: theme.palette.colorTheme.containerPrimaryOnDark,
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.colorTheme.containerSecondaryOnLight,
  },
  '&:focus': {
    cursor: 'pointer',
    backgroundColor: theme.palette.colorTheme.containerSecondaryOnLight,
  },
  ...(disabled && {
    borderColor: theme.palette.colorTheme.contentDisabled,
    color: theme.palette.colorTheme.contentDisabled,
  }),
  ...(variant === 'pressed' && {
    backgroundColor: theme.palette.colorTheme.onLightPressed,
  }),
}));

export default ButtonOnDark;
